<!--
  ~ Copyright 2022-2023 NXGN Management, LLC. All Rights Reserved.
  -->

<div class="modal-content border-0">
  <div class="modal-header">
    <div class="modal-title">Confirm Merchant Migration</div>
  </div>
  <div class="modal-body">
    {{ getConfirmationMessage() }}
  </div>
  <div class="modal-footer">
    <button type="button" (click)="cancel()" class="btn btn-light">
      <span class="oi oi-x"></span>
      Cancel
    </button>
    <button
      type="button"
      (click)="handleConfirm()"
      *ngIf="!merchantMigrationInfo.toBeMigrated"
      class="btn btn-primary"
    >
      <span>
        <fa-icon [icon]="faCheck"></fa-icon>
      </span>
      Confirm
    </button>
  </div>
</div>
